import { render, staticRenderFns } from "./bannerModule.vue?vue&type=template&id=c66a122a&scoped=true&"
import script from "./bannerModule.vue?vue&type=script&lang=js&"
export * from "./bannerModule.vue?vue&type=script&lang=js&"
import style0 from "./bannerModule.vue?vue&type=style&index=0&id=c66a122a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66a122a",
  null
  
)

export default component.exports